/**
 * TagManager Constants - Centralized string literals for the TagManager component
 */

export const TAG_MANAGER_STRINGS = {
  LOADING_TAGS: 'Loading tags...' as const,
  SAVING_TAGS: 'Updating your tags...' as const,

  DRAWER_TITLE: 'Manage Tags' as const,

  CANCEL: 'Cancel' as const,
  CREATE_NEW_TAG: 'Create a New Tag' as const,
  SAVE: 'Save' as const,
  SAVING: 'Saving...' as const,

  SELECT_TAG_COLOR: 'Select tag color' as const,
  DELETE_TAG: 'Delete tag' as const,
  SELECT_COLOR: 'Select {colorName} color' as const,

  // Delete confirmation modal
  DELETE_TAG_TITLE: 'Delete tag?' as const,
  DELETE_TAG_DESCRIPTION: 'Are you sure you want to delete this tag? This action will delete the tag across all of Financials and cannot be undone.' as const,
  DELETE_TAG_BUTTON: 'Delete' as const,
  DELETE_TAG_CANCEL: 'Cancel' as const,

  TAGS_FIELD: 'tags' as const,

  TEST_ID_COLOR_PICKER: 'tag-color-picker' as const,
  TEST_ID_COLOR_OPTION_PREFIX: 'tag-color-picker-option-' as const,

  ARROW_RIGHT: 'ArrowRight' as const,
  ARROW_LEFT: 'ArrowLeft' as const,
  ARROW_DOWN: 'ArrowDown' as const,
  ARROW_UP: 'ArrowUp' as const,
  ENTER: 'Enter' as const,
  SPACE: ' ' as const,

  SOURCE_CREATE: 'create' as const,
  SOURCE_EDIT: 'edit' as const
} as const;

export const formatString = (
  template: string,
  replacements: Record<string, string>
): string => {
  return template.replace(
    /{(\w+)}/g,
    (match, key) => replacements[key] || match
  );
};

/**
 * Shared tag copy. Lives here rather than in a screen's constants so that
 * `components/TagManager` and `components/TagsPicker` do not depend on any screen;
 * `Applications&WorkOrders` re-exports these through its own `LayoutStrings`.
 */
export const TAG_SORT_OPTION_STRINGS = {
  nameAsc: 'Name (A→Z)',
  nameDesc: 'Name (Z→A)',
  color: 'Color'
} as const;

export const TAG_ACTION_STRINGS = {
  searchTags: 'Search tags',
  sort: 'Sort',
  manage: 'Manage',
  createNewTag: 'Create a New Tag'
} as const;

export const TAG_STRINGS = {
  emptyStateTitle: 'No Tags Found',
  loadingMessage: 'Loading your tags...',
  noTagsAvailable: 'No tags available.',
  noSearchResultsTitle: 'No Tags Found',
  noSearchResultsMessage: 'Please try a different search.',
  saveSuccessMultiple: 'New tags have been saved!',
  saveSuccessSingle: 'New tag has been saved!',
  savePartialErrorTitle: 'Some tags have not been saved',
  savePartialErrorContent:
    'An error prevented some of your tags from being saved. Please try again.',
  saveErrorTitle: 'Unable to save your tags',
  saveErrorContent:
    'An error prevented your tags from being saved. Please try again.'
} as const;

// The toast's own width is a fraction of the viewport (w-2/6), which renders
// 640px at 1920 where the design draws a fixed 400px notification.
export const TOAST_STYLE = { width: '400px' };
